import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux';


export const PublicRoute = ({
    component: Component,
    ...rest
}) => {

    const { isLoggedIn } = useSelector( state => state.auth);

    return (
        <Route { ...rest }
            component={ (props) => (
                ( isLoggedIn )
                    ? ( <Redirect to="/" /> )
                    : ( <Component { ...props } /> )
            )}
        
        />
    )
}

PublicRoute.propTypes = {
    component: PropTypes.func.isRequired
}
